import React, { useState, useEffect } from 'react';
import { IonCol, IonTextarea, IonButton, IonRow, IonGrid, IonInput } from '@ionic/react';

import { ValidatorMessageComponent } from '../../components';

export const ContactComponent = ({
    message,
    name,
    handleInputChange,
    pageConfig,
    handleMessage,
    inputs,
    validation,
    showInputName
}) => {

    const [counter, setCounter] = useState(pageConfig.rules.inputs[inputs.message].maxLength.value);

    /**
     * Manipula el contador de caracteres del textarea
     */
    useEffect(() => {
        
        if ( message.length <= pageConfig.rules.inputs[inputs.message].maxLength.value) {

            setCounter(pageConfig.rules.inputs[inputs.message].maxLength.value - message.length);
        }
        else {

            setCounter(0);
        }

    }, [message]);

    return (

        <form onSubmit={handleMessage} noValidate>
            <IonGrid>
                <IonRow className="grid-rows-3">
                    <IonCol>
                        <p className="subtitle">Te pedimos la mayor cantidad de datos para darte una mejor respuesta</p>
                    </IonCol>
                    <IonCol>

                        {
                            showInputName &&
                            <>
                                    <IonInput
                                        name='name'
                                        type="text"
                                        value={name}
                                        className="establecimiento"
                                        placeholder="Establecimiento"
                                        onIonChange={handleInputChange}
                                        required={pageConfig.rules.inputs[inputs.name].required.value}
                                        min={pageConfig.rules.inputs[inputs.name].minLength.value}
                                        max={pageConfig.rules.inputs[inputs.name].maxLength.value}
                                        maxLength={pageConfig.rules.inputs[inputs.name].maxLength.value}
                                    >
                                    </IonInput>
                                {
                                    validation.summary?.map((v, index) => {

                                        return v.key === inputs.name &&
                                            <ValidatorMessageComponent key={index} message={v.message} />
                                    })
                                }
                            </>
                        }

                        <IonTextarea
                            name='message'
                            type="text"
                            rows={pageConfig.attributes[inputs.message].rows}
                            placeholder={pageConfig.attributes[inputs.message].placeholder}
                            value={message}
                            onIonChange={handleInputChange}
                            minLength={pageConfig.rules.inputs[inputs.message].minLength.value}
                            maxLength={pageConfig.rules.inputs[inputs.message].maxLength.value}
                            required={pageConfig.rules.inputs[inputs.message].required.value}
                        >
                        </IonTextarea>
                        <p className="limitLetter"> { pageConfig.rules.inputs[inputs.message].maxLength.value }/{counter}</p>
                        {
                            validation.summary?.map((v, index) => {

                                return v.key === inputs.message &&
                                    <ValidatorMessageComponent key={index} message={v.message} />
                            })
                        }
                    </IonCol>
                    <IonCol className="dispFlex-justCenter">
                        <IonButton
                            type="submit"
                            shape="round"
                            size="undefined"
                            disabled={!validation.formComplete || !validation.formValid}
                        >
                            Enviar Consulta
                        </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </form>
    )
}
